import { Dialog, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isMember: boolean;
  maxCount: number;
}

const OptimizationLimitDialog = ({ open, onOpenChange, isMember, maxCount }: Props) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent noCloseBtn className="w-[360px] p-[30px]">
        <div className="flex flex-col items-start">
          <div className="text-gr-900 Title3S18">이번달 상품 진단 횟수가 초과됐어요</div>
          <div className="mt-[4px] whitespace-pre-line text-gr-700 Body5M14">
            {isMember
              ? `최대 ${maxCount}개의 상품까지 진단 할 수 있어요.`
              : `최대 ${maxCount}개의 상품까지 진단 할 수 있어요\n멤버십을 가입할까요?`}
          </div>
          <div className="mt-[20px] flex w-full gap-3">
            <DialogClose asChild>
              <Button variant="muted" className="h-[48px] flex-1">
                닫기
              </Button>
            </DialogClose>
            {!isMember && (
              <Button
                variant="default"
                className="h-[48px] flex-1"
                onClick={() => {
                  onOpenChange(false);
                  navigate(ROUTES.moreMembership);
                }}
              >
                멤버십 가입
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OptimizationLimitDialog;
